module.exports = {"asl.heading":"ASL"}


//////////////////
// WEBPACK FOOTER
// ./src/components/i18n/locales/ja.json
// module id = 707
// module chunks = 0